import {
  NotificationsProvider as MuiNotificationsProvider,
  type NotificationsProviderSlotProps,
} from '@toolpad/core/useNotifications';

import type { HTMLDataAttributes } from '../../types/data-attributes';

const rootSlotProp: HTMLDataAttributes = {
  'data-testid': 'notification-snackbar',
};

const slotProps: NotificationsProviderSlotProps = {
  snackbar: {
    anchorOrigin: { vertical: 'top', horizontal: 'right' },
    sx: { maxWidth: 400 },
    slotProps: {
      root: rootSlotProp,
    },
  },
};

export const NotificationsProvider = ({
  children,
}: React.PropsWithChildren) => (
  <MuiNotificationsProvider slotProps={slotProps}>
    {children}
  </MuiNotificationsProvider>
);
